import { render, staticRenderFns } from "./ReportCard.vue?vue&type=template&id=b774c1ee&scoped=true&"
import script from "./ReportCard.vue?vue&type=script&lang=js&"
export * from "./ReportCard.vue?vue&type=script&lang=js&"
import style0 from "./ReportCard.vue?vue&type=style&index=0&id=b774c1ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b774c1ee",
  null
  
)

export default component.exports